import type { RouteObject } from 'react-router-dom';
import { ROUTE_LABS } from '../../../constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { Page } from './labs.page';

export const routeLabs: RouteObject = {
  path: ROUTE_LABS,
  Component: Page,
  loader: setTitleFromLoader('Catch Labs'),
};